"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_FLATPICKR_TO = exports.DATA_FLATPICKR_FROM = exports.DATA_FLATPICKR_FORM = exports.DATA_FLATPICKR = exports.DATA_QUICKMESSAGE_CLOSE = exports.DATA_QUICKMESSAGE = exports.DATA_PANORAMA = exports.DATA_ACCORDION = exports.DATA_SLIDER_TEASERBOXES = exports.DATA_SLIDER = exports.DATA_NAVIGATION_SUB_BACK = exports.DATA_NAVIGATION_SUB_OPEN = exports.DATA_NAVIGATION_ITEM = exports.DATA_NAVIGATION_MENU = exports.DATA_MODAL_FAQ = exports.DATA_MODAL_CLOSE = exports.DATA_MODAL_TRIGGER = exports.DATA_MODAL = exports.DATA_STICKY_BUTTONS_WRAPPER = exports.DATA_STICKY_BUTTONS = exports.DATA_HEADER_MENU_BTN = exports.DATA_HEADER = void 0;
exports.DATA_HEADER = 'data-header';
exports.DATA_HEADER_MENU_BTN = 'data-header-menu-btn';
exports.DATA_STICKY_BUTTONS = 'data-sticky-buttons';
exports.DATA_STICKY_BUTTONS_WRAPPER = 'data-sticky-buttons-wrapper';
exports.DATA_MODAL = 'data-modal';
exports.DATA_MODAL_TRIGGER = 'data-modal-trigger';
exports.DATA_MODAL_CLOSE = 'data-modal-close';
exports.DATA_MODAL_FAQ = 'data-modal-faq';
exports.DATA_NAVIGATION_MENU = 'data-navigation-menu';
exports.DATA_NAVIGATION_ITEM = 'data-navigation-item';
exports.DATA_NAVIGATION_SUB_OPEN = 'data-navigation-sub-open';
exports.DATA_NAVIGATION_SUB_BACK = 'data-navigation-sub-back';
exports.DATA_SLIDER = 'data-slider';
exports.DATA_SLIDER_TEASERBOXES = 'data-slider-teaserboxes';
exports.DATA_ACCORDION = 'data-bs-toggle';
exports.DATA_PANORAMA = 'data-panorama';
exports.DATA_QUICKMESSAGE = 'data-quickmessage';
exports.DATA_QUICKMESSAGE_CLOSE = 'data-quickmessage-close';
exports.DATA_FLATPICKR = 'data-flatpickr';
exports.DATA_FLATPICKR_FORM = 'data-flatpickr-form';
exports.DATA_FLATPICKR_FROM = 'data-flatpickr-from';
exports.DATA_FLATPICKR_TO = 'data-flatpickr-to';
